/**
* @file Route: search
*
* This file is compiled as a standalone entrypoint and it is included by
* default in its blade template.
* This is a "standard" route, it does not have a structure to follow, you are
* sure the DOM is always ready and the JS will only be executed in this route.
*/

import "layouts/main";
import "components/Title";
// import { AjaxConfig, Ajax } from "@olmokit/core/ajax";
import { Search, Result, urlQuery } from "components/Search";
import "./index.scss";

Search('#searchbar', '#buttonsearchbar');

const query = urlQuery();
Result(query);

console.log("Route search/index.js mounted.");
